<template>
	<b-container class="show-document">
		<div class="doc-body">
			<div class="row hidden-print" style="margin-top: 6px;">
				<div class="col-9">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back')
						}}
					</b-button>
				</div>
				<div class="col-3">
					<b-button
						variant="outline-dark"
						@click="print"
						class="mr-2"
					>
						<i class="fa fa-print"></i>
						{{ $t('pricing.print')}}
					</b-button>
				</div>

			</div>
			<b-card class="mt-3">

				<div class="row">
					<div class="col-9">
						<h3 class="text-center mt-2 font-weight-bold">
							{{$t('sidebar.warehouse-management.extra-cost-title')}} №
							<small>{{ item.regNumber }}</small>
						</h3>
					</div>

					<div class="col-3">
						<h4 class="text-center mt-2  text-uppercase"><span style="font-weight: bold">{{$t('incomes.date')}}: </span>{{item.regDate}}</h4>
					</div>
				</div>


				<div class="generalTableClass documentItems mt-5">
					<table class="table table-striped">
						<thead>
						<tr>
							<th>№</th>
							<th>{{ $t('contragent.category-name') }}</th>
							<th>{{ $t('pos.sum') }}</th>
							<th style=" display: flex;justify-content: center;">{{ $t('incomes.create.comment') }}
							</th>
							<!--<th>{{ $t('incomes.create.price')  }} USD</th>-->
							<!--<th>{{ $t('incomes.create.price')  }} Сум</th>-->
							<!--<th>{{ $t('incomes.create.comment') }}</th>-->
						</tr>
						</thead>

						<tbody>
						<tr v-for="cost,index in extraCosts" :key="cost.id">
							<td>{{ index +1 }}</td>
							<td>{{ cost.categoryName }}</td>
							<td>{{cost.cost| currency({
								symbol:
								userDepCurrencyName, fractionCount: 2, symbolPosition: 'back'
								})}}
							</td>
							<td style=" display: flex;
    justify-content: center;">{{ cost.comment }}
							</td>
							<!--<td>{{ cost.costUsd }}</td>-->
							<!--<td>{{ cost.costUzs }}</td>-->
							<!--<td>{{ cost.comment }}</td>-->
						</tr>
						</tbody>
					</table>
				</div>

			</b-card>
		</div>
	</b-container>
</template>

<script>
	import {mapState} from 'vuex'
	import WhDocument from "../../../../services/wh-document.service";
	import ExtraCost from "../../../../services/extraCost.service";

	export default {
		name: 'ExtraCost',

		data() {
			return {
				depCurrencyCode: '',
				item: {},
				extraCosts: []
			}
		},
		computed: {
            ...mapState(['userDepCurrencyName']),
		},
		methods: {
			print(){
				window.print();
			},
			goBackToFrom() {
				this.$router.back();
			},
			loadItem() {
				WhDocument.get(this.$route.params.id).then(response => {
					this.item = response.data;
				});
			},
			loadCosts() {
				ExtraCost.loadByDocument(this.$route.params.id).then(response => {
					this.extraCosts = response;
				})
			}
		},

		created() {
			this.loadItem()
			this.loadCosts();
			this.depCurrencyCode = localStorage.getItem("depCurrencyName");
		}
	}
</script>

<style scoped>
	@media print {
		.hidden-print {
			display: none;
		}

		.card {
			box-shadow: none;
		}
	}
</style>
